<div class="body fs-body">
   <h3 class="fw-sbold cl-primary-v2 fs-35">AutoGrowth</h3>
   <p class="fs-14 cl-black">Deja que tu dinero trabaje solito, todos los días.</p>

   <p class="fs-14 cl-black"><strong>✔ Tú decides:</strong> Elige cómo y en qué tipo de proyectos quieres invertir. Nosotros lo hacemos por ti.</p>
   <p class="fs-14 cl-black mb-4"><strong>✔ Tu lana no se duerme: </strong>  Cuando juntes $1,000 MXN, lo invertimos por ti en automático. Todos los días, sin falta.</p>

   <form [formGroup]="autoInvestForm" class="mb-4 mt-2">

      <p class="fs-15 cl-primary-v2 m-0"><strong>Criterios de preferencia</strong></p>

      <h3 class="mt-3 cl-black fw-bold m-0 mb-2 fs-22">¿En qué proyectos quieres que se mueva tu dinero?</h3>

      <mat-radio-group formControlName="selectedOption" (change)="onOptionChange($event.value)" class="mt-3">
         <div class="item br-top">
            <p [ngClass]="{'fw-bold': selectedValue === 'allProjects'}" class="cl-black fs-15 m-0"> <strong>Todos los proyectos activos:</strong> Diversificamos y empezamos por los que están a punto de fondearse.</p>
            <mat-radio-button value="allProjects"></mat-radio-button>
         </div>
         <div class="item">
            <p [ngClass]="{'fw-bold': selectedValue === 'fixed'}" class="cl-black fs-15 m-0"> <strong> Solo rendimiento fijo:</strong> Estabilidad ante todo. Diversificamos dentro de los proyectos más avanzados.</p>
            <mat-radio-button value="fixed"></mat-radio-button>
         </div>
         <div class="item">
            <p [ngClass]="{'fw-bold': selectedValue === 'variable'}" class="cl-black fs-15 m-0"> <strong>Solo rendimiento variable:</strong> Mayor potencial, más emoción. También diversificado y priorizando los que están por cerrarse.</p>
            <mat-radio-button value="variable"></mat-radio-button>
         </div>
      </mat-radio-group>
      

      <button class="btn cl-white bg-primary-card m-auto d-block btn-padding mt-5" (click)="openAutoInvestContract()" [disabled]="autoInvestForm.invalid">Activar AutoGrowth</button>

   </form>

   <div class="info-s col-12 m-auto p-3">
      <div class="d-block m-auto text-center d-md-flex align-items-md-center justify-content-md-between">
         <div class="mt-3 mt-md-0">
             <button class="btn cl-white bg-primary-card btn-padding" [class.selected]="currentParagraph === 1" (click)="showParagraph(1)">
                 ¿Cómo funciona?
             </button>
         </div>
         <div class="mt-3 mt-md-0">
             <button class="btn cl-white bg-primary-card btn-padding" [class.selected]="currentParagraph === 2" (click)="showParagraph(2)">
                 Tu dinero trabaja diario
             </button>
         </div>
         <div class="mt-3 mt-md-0">
             <button class="btn cl-white bg-primary-card btn-padding" [class.selected]="currentParagraph === 3" (click)="showParagraph(3)">
                 Cancelaciones
             </button>
         </div>
     </div>     
      <div class="pt-4">
         <div>
            <div *ngIf="currentParagraph === 1" class="animated fadeIn cl-black fs-13">
               <br><p class="m-0">AutoGrowth es tu piloto automático para invertir.</p><br>
               <p class="m-0">Todos los días a las 8:00 p.m. (CDMX), revisamos tu cuenta. Si tienes al menos $1,000 MXN disponibles, invertimos por ti según tus preferencias.</p><br>
               <p class="m-0">Priorizamos los proyectos más llenos (los que están por fondearse) y distribuimos tu dinero entre varios para reducir riesgos.</p>
               <p class="m-0">Conoce más <a href="https://centrodeayuda.monific.com/qu%C3%A9-es-autogrowth-y-c%C3%B3mo-funciona" target="_blank" rel="noopener noreferrer">aquí</a></p>
            </div>
            <p class="animated fadeIn fs-13 pt-1 cl-black" *ngIf="currentParagraph === 2">
               Cada peso que acumulas cuenta.<br><br>
               Una vez que juntas <strong>$1,000 MXN</strong>, AutoGrowth entra en acción.<br><br>
               Reinversión automática sin que muevas un dedo. Tú relájate, tu dinero no.
            </p>
            <p class="animated fadeIn fs-13 pt-1 cl-black" *ngIf="currentParagraph === 3">¿Te arrepentiste? Apagas AutoGrowth desde tu cuenta con un solo clic.</p>
         </div>
      </div>
   </div>
</div>
